import { useNavigate, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import axiosInstance from '../api/axiosInstance';
import { useForm } from "react-hook-form"
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
// toast-configuration method,
// it is compulsory method.

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/linkpage"
  const [error, setError] = useState('');
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
    },
  })
  const watchUsername = watch("username")

const onSubmit = async (data) => {
      try {
        var form = new FormData();
        form.append("email", data.username);
        const res = await axiosInstance.post('/forget-password', form)
        .then(res=> {
          var result_data = res.data;
          if(result_data?.status === 'Ok'){
            toast.success(result_data.message);
            setTimeout(function(){
              navigate('/');
            },3000);
          }
          else{
            toast.error(result_data.message);
          }
        })
      }
      catch(err){
          if(!err?.response){
            toast.error('no server response');
          }
          else {
            toast.error('Something went wrong!')
          }
      }
}
useEffect(() => {
  // form label move on focus start
    $(".form_group .form-control").focus(function(){
      $(this).parent().addClass('focus_label');
     })
     .blur(function(){
      var tmpval = $(this).val();
      if(tmpval === '') {
          $(this).parent().removeClass('focus_label');
      }
    })
    // form label move on focus end
 },[])

  return (  
    <main className="main-content main_vert_center">
      <div className="login_flow_wrap">
        <div className="row align-items-center">
          <div className="col-md-6 order-md-2">
            <div className="loginflow_right">
              <div className="loginflow_logo">
                <img src="images/logo.svg" alt="logo" />
              </div>
              <h1>Forgot Password</h1>
              <form className="form_common" onSubmit={handleSubmit(onSubmit)} noValidate>
                <div className="form_group">
                  <label className="form-label">Email ID <span className="req_star">*</span></label>
                  <input type="email" className={'form-control ' + (errors.username ? 'error' : ' ')} autoComplete='off' 
                  {...register("username", {value: '', required: true, 
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Please enter a valid email.",
                  }})} />
                    {errors.username && errors.username.type === "required" && (
                    <span className='input-error'>Please enter your email.</span>
                  )}
                  {errors.username && errors.username.type === "pattern" && (
                    <span className='input-error'>{errors.username.message}</span>
                  )}
                </div>
                <div className="frm_btn_full">
                  <button type="submit" className='btn btn_cmn'>Send Recovery Link</button>
                </div>
                <div className="frm_btm_link text-center">
                  <Link to="/login"><i className="fa fa-arrow-left" aria-hidden="true"></i> Back</Link>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginflow_left">
              <figure><img src="images/login_flow_left_img.jpg" alt="Login" /></figure>
              <div className="loginflow_left_cap">
                <h4>Lorem ipsum dolor sit amet consectetur. Nulla elementum </h4>
                <p className="mb-0">Lorem ipsum dolor sit amet consectetur. Pellentesque id vel nisl volutpat maecenas. Vitae nulla viverra dolor eget interdum massa ac sagittis.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnFocusLoss={false}
        pauseOnHover
        theme="colored"
        />
    </main>                                     
  )
}

export default ForgotPassword
